export class CalendarEventSubTask {
    //netgen start
    calendarEventId = 0;
    order = 0;
    title: string;
    finished = false;
    id = 0;
    //netgen end
}
